import axios from 'axios';

/**
 * The backend's refusal of a sixth account in one browser (409 `too_many_accounts`,
 * docs/MultiAccountSessions.md §2), or `undefined` for any other failure. Shown as it stands:
 * it says what to do, which "invalid username or password" would not.
 */
export function tooManyAccountsMessage(e: unknown): string | undefined {
  if (!axios.isAxiosError(e) || e.response?.status !== 409) return undefined;
  const data = e.response.data as { error?: string; description?: string } | undefined;
  return data?.error === 'too_many_accounts' ? data.description : undefined;
}
